/*
 * @Author: Czy 1162306744@qq.com
 * @Date: 2026-03-05 11:20:04
 * @LastEditors: Czy 1162306744@qq.com
 * @LastEditTime: 2026-03-05 14:07:44
 * @FilePath: /ayh-mobile-overseas/src/utils/i18n.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import i18n from '@/i18n'
import { useLanguageStore } from '@/store'
import { LANGUAGE_CODE_MAP } from '@/i18n'
import { Locale } from 'wot-design-uni'
import enUS from 'wot-design-uni/locale/lang/en-US'
import zhCN from 'wot-design-uni/locale/lang/zh-CN'

/**
 * 同步语言 store 和 i18n
 * 当用户在设置页面选择语言时，需要调用此函数来更新 i18n 的 locale
 */
export const syncLanguageToI18n = () => {
  const languageStore = useLanguageStore()

  if (languageStore.currentLanguage?.languageCode) {
    const languageCode = languageStore.currentLanguage.languageCode
    const i18nLocale = LANGUAGE_CODE_MAP[languageCode] || 'en'
    i18n.global.locale.value = i18nLocale

    // 同步 wot-design-uni 的语言
    if (i18nLocale === 'zh-CN') {
      Locale.use('zh-CN', zhCN)
    } else {
      Locale.use('en-US', enUS)
    }

    // 同步 UniApp 的 locale
    uni.setLocale(i18nLocale)

    // 更新当前页面的标题
    updateCurrentPageTitle()

    console.log(`[i18n] 语言已切换为: ${i18nLocale}`)
  }
}

/**
 * 更新当前页面的标题
 * 根据当前路由和 i18n 配置动态更新页面标题
 */
export const updateCurrentPageTitle = () => {
  const pages = getCurrentPages()
  if (pages.length === 0) return

  const currentPage = pages[pages.length - 1]
  const route = currentPage.route

  // 页面路由到 i18n key 的映射
  const pageTitleMap: Record<string, string> = {
    'pages/set-up/index': 'page.settings',
    'pages-sub/search-city/index': 'page.selectDestination',
    'pages-sub/hotel/hotel-list/index': 'page.hotelList',
    'pages-sub/contact-us/index': 'page.contactUs',
    'pages-sub/user-agreement/index': 'page.userAgreement',
    'pages-sub/privacy-agreement/index': 'page.privacyPolicy',
    'pages/travelers/index': 'page.travelers',
    'pages-sub/select-travelers/index': 'page.selectContact',
    'pages-sub/pay/index': 'page.payment',
    'pages/my/index': 'page.my',
    'pages-sub/search-city/select-room-data': 'page.selectRoomAndGuests',
  }

  const titleKey = pageTitleMap[route || '']
  if (titleKey) {
    const title = i18n.global.t(titleKey)
    uni.setNavigationBarTitle({ title })
  }
}

/**
 * 初始化 i18n 语言
 * 在应用启动时调用，从 store 中恢复之前保存的语言设置
 */
export const initializeI18nLanguage = () => {
  const languageStore = useLanguageStore()

  console.log('[i18n] 初始化语言 - store 中的语言:', languageStore.currentLanguage)

  if (languageStore.currentLanguage?.languageCode) {
    const languageCode = languageStore.currentLanguage.languageCode
    const i18nLocale = LANGUAGE_CODE_MAP[languageCode] || 'en'
    i18n.global.locale.value = i18nLocale

    // 同步 wot-design-uni 的语言
    if (i18nLocale === 'zh-CN') {
      Locale.use('zh-CN', zhCN)
    } else {
      Locale.use('en-US', enUS)
    }

    // 同步 UniApp 的 locale
    uni.setLocale(i18nLocale)

    console.log(`[i18n] 初始化语言为: ${i18nLocale} (来自 store: ${languageCode})`)
  } else {
    // 如果 store 中没有保存的语言，默认使用英文
    const defaultLocale = 'en'
    i18n.global.locale.value = defaultLocale

    // 同步 wot-design-uni 的语言
    Locale.use('en-US', enUS)

    uni.setLocale(defaultLocale)
    console.log(`[i18n] 使用默认语言: ${defaultLocale}`)
  }
}

/**
 * 获取当前 i18n 的 locale
 */
export const getCurrentLocale = (): string => {
  return i18n.global.locale.value
}

/**
 * 设置 i18n 的 locale
 */
export const setI18nLocale = (localeCode: string) => {
  i18n.global.locale.value = localeCode
  console.log(`[i18n] 语言已设置为: ${localeCode}`)
}
